// Efeitos das notificações de CONTRATO DE EVENTO.
// Registrado em `constants/notificationHandlers.ts`.
//
// O preenchimento do contrato não notifica mais por WebSocket: gerar é síncrono
// (sem IA) e as leituras com IA — do template e das fontes — são acompanhadas
// por polling na tarefa. Sobrou só o push da assinatura.

import type { MapaDeHandlers } from '../../constants/notificationHandlers';

/** O que CONTRATO DE EVENTO le' da mensagem do WebSocket. */
export interface DadosWsEventos {
  contrato_id?: number;
  evento_id?: number;
  status?: string;
}

/**
 * O que CONTRATO DE EVENTO grava no `dados_json` PERSISTIDO.
 *
 * ⚠️ Este `contrato_id`, de `tb_evento_contrato`, colide com o de
 * `tb_contrato_societario` — e e' por isso que `destinoSocietario` exige o
 * dominio ANTES do id.
 */
export interface DadosJsonEventos {
  contrato_id?: number;
  evento_id?: number;
}

export const HANDLERS_EVENTOS: MapaDeHandlers = {
  /**
   * Push do webhook Autentique: contrato de evento assinado ou rejeitado
   * (payload: card_id, contrato_id, status). Re-fetch do board de eventos e do
   * contrato — a API é a fonte da verdade, aqui só invalidamos cache.
   */
  contrato_assinatura: ({ message, queryClient }) => {
    const d = message.data;
    if (d.contrato_id) {
      queryClient.invalidateQueries({ queryKey: ['contrato', d.contrato_id] });
    }
    queryClient.invalidateQueries({ queryKey: ['evento-contratos'] });
    queryClient.invalidateQueries({ queryKey: ['eventos'] });
    queryClient.invalidateQueries({ queryKey: ['kanban-board'] });
    // A aba Assinatura aberta atualiza junto, sem esperar o intervalo.
    queryClient.invalidateQueries({ queryKey: ['kanban-assinatura'] });
  },
};
